import LetterAvatar from "@/components/Avatar/LetterAvatar"

export const columns = [
  {
    header: "Name",
    accessorKey: "name",
  },
  {
    header: "Created At",
    accessorKey: "created_at",
  },
]
